import type { KnowledgeArticle } from "../types"

export const ragVsFineTuning: KnowledgeArticle = {
  id: "insight:rag-vs-fine-tuning",
  pageType: "knowledge-article",
  slug: { nl: "rag-vs-fine-tuning" },
  title: {
    nl: "RAG of Fine-tuning? | Wanneer is RAG beter dan fine-tuning",
    en: "RAG of Fine-tuning? | Wanneer is RAG beter dan fine-tuning",
  },
  description: {
    nl: "RAG of fine-tuning voor bedrijfswissen? Waarom retrieval meestal wint voor kennisvragen, en wanneer fine-tuning alsnog de juiste keuze is.",
    en: "RAG or fine-tuning for company knowledge? Why retrieval usually wins for knowledge questions, and when fine-tuning is still the right call.",
  },
  h1: {
    nl: "RAG of fine-tuning?",
    en: "RAG of fine-tuning?",
  },
  published: "2026-08-26",
  modified: "2026-08-26",
  author: "Camiel Schmeitz",
  sections: [
    {
      type: "paragraph",
      text: "Bedrijven die eigen kennis in een taalmodel willen stoppen, komen vroeg of laat bij dezelfde vraag uit: fijnafstellen (fine-tunen) we het model op onze data, of bouwen we retrieval eromheen (RAG)? Voor kennisdeling is het antwoord vrij consequent.",
    },
    {
      type: "heading",
      text: "Het fundamentele verschil",
    },
    {
      type: "paragraph",
      text: "Fine-tuning verandert de gewichten van het model: kennis wordt 'ingebacked' in parameters. RAG laat het model intact en geeft het toegang tot een zoekbare kennisbank op het moment van de vraag. Dat klinkt als een detail, maar heeft grote praktische gevolgen.",
    },
    {
      type: "heading",
      text: "Waarom RAG wint bij kennisvragen",
    },
    {
      type: "list",
      items: [
        "Actualiteit: nieuwe documentatie indexeren is een update; nieuwe kennis in gewichten bakken betekent opnieuw trainen.",
        "Traceerbaarheid: RAG kan verwijzen naar de bronpassage; een getuned model citeert niets controleerbaars.",
        "Kosten: RAG-schaling is infrastructuur; hertrainen bij elke wijziging is structureel duurder.",
        "Toegangsbeheer: wie welke documentatie mag zien, regel je in retrieval; gewichten kennen geen rechten.",
        "Hallucinatiebeheersing: antwoorden gestoeld op gevonden passages zijn aantoonbaar beter grondvest dan 'onthouden'.",
      ],
    },
    {
      type: "heading",
      text: "Wanneer fine-tuning wél zin heeft",
    },
    {
      type: "paragraph",
      text: "Fine-tuning gaat niet primair over kennis, maar over gedrag en vorm: vaste outputformaten, huisstijl van taal, specifieke classificatiegrenzen, domeinspecifieke terminologie consistent toepassen. Ook bij compacte lokale modellen kan tuning helpen om een taak met beperkte middelen goed uit te voeren. Maar zodra de vraag is 'weet ons systeem wat er in onze documenten staat', is fine-tuning doorgaans de verkeerde tool.",
    },
    {
      type: "heading",
      text: "Combinaties zijn mogelijk",
    },
    {
      type: "paragraph",
      text: "In de praktijk sluiten ze elkaar niet uit: een licht getund model dat strikt de huistijl volgt, gecombineerd met RAG voor de feitelijke onderbouwing, komt voor. De bouwvolgorde blijft echter: eerst retrieval goed krijgen, pas daarna tuning overwegen — anders optimaliseer je gedrag boven feiten.",
    },
    {
      type: "callout",
      title: "Vuistregel",
      text: "Kennis → RAG. Gedrag/vorm → fine-tuning. Twijfel je nog, begin dan met RAG: goedkopere iteraties, betere controle, makkelijker te evalueren.",
    },
  ],
  relatedServiceIds: ["ai-knowledge-systems", "ai-development"],
  relatedCaseIds: ["burgerkracht"],
}
